import { StorageType } from 'types'

/**
 * Wrapper & helper for storage classes
 */
export default class StorageHelper implements StorageType {
  storage: Storage

  /**
   * @param {Object} driver - Driver object that implements storage interface, usually LocalStorage or SessionStorage
   */
  constructor(driver: Storage) {
    this.storage = driver
  }

  /**
   * Check if storage has a key set
   */
  has(key: string): boolean {
    for (let k = 0 ; k < this.storage.length ; k++) {
      if (this.storage.key(k) === key) {
        return true
      }
    }
    return false
  }

  /**
   * Get value from storage, automatically parse JSON
   */
  getItem(key: string): any {
    let value = this.storage.getItem(key)
    if (typeof value === 'string') {
      value = JSON.parse(value)
    }
    return value
  }

  /**
   * Set value to storage, automatically encode JSON
   */
  setItem(key: string, value: any): any {
    this.storage.setItem(key, JSON.stringify(value))
    return value
  }

  /**
   * Remove entry in storage
   */
  removeItem(key: string): StorageHelper {
    this.storage.removeItem(key)
    return this
  }

  /**
   * Clear all storage entries
   */
  clear(): StorageHelper {
    this.storage.clear()
    return this
  }

  length(): number {
    return this.storage.length
  }

  key(key) {
    return this.storage.key(key)
  }

  keys() {
    return this.storage.keys()
  }
}